<script>
import Datepicker from 'vuejs-datepicker';
import VendorApi from '@/api/vendor';
import {mapState} from 'vuex';

export default {
  name: 'ReservationsToClean',
  components: {Datepicker},
  data() {
    return {
      dpkConfig: this.$helper.dpkBasicConfig(),
      tableFields: [
        'departure',
        {key: 'isPriorityClean', label: 'Priority'},
        {key: 'cleaningVendor', label: 'Vendor'},
        {key: 'unitId', label: 'Unit'},
        {key: 'propertyAddress', label: 'Address'},
        {key: 'telephoneNumber', label: 'Telephone'},
        {key: 'reservationNumber', label: 'Reservation Number'},
        {key: 'nextArrival', label: 'Next Arrival'},
        {key: 'isClean', label: 'Cleaned?', class: 'text-center'}
      ],
      items: [],
      startDate: this.$moment().format('MM/DD/YYYY'),
      endDate: this.$moment().format('MM/DD/YYYY'),
      disabledStartDate: {},
      disabledEndDate: {},
      apiMessageModal: false,
      apiMessage: '',
      modalImage: ''
    };
  },
  computed: {
    ...mapState({
      datePicked: state => state.common.datePicked,
      cleaningInfo: state => state.common.cleaningInfo
    })
  },
  watch: {
    startDate(newStartDate) {
      if (newStartDate) {
        this.disabledEndDate = {
          to: new Date(this.$moment(this.startDate, 'MM/DD/YYYY'))
        };
        this.$store.dispatch('common/updateDate', {
          startDate: this.$moment(newStartDate, 'MM/DD/YYYY').format('MM/DD/YYYY'),
          endDate: this.$moment(this.endDate, 'MM/DD/YYYY').format('MM/DD/YYYY')
        });
      }
    },
    endDate(newEndDate) {
      if (newEndDate) {
        this.disabledStartDate = {
          from: new Date(this.$moment(this.endDate, 'MM/DD/YYYY'))
        };
        this.$store.dispatch('common/updateDate', {
          startDate: this.$moment(this.startDate, 'MM/DD/YYYY').format('MM/DD/YYYY'),
          endDate: this.$moment(newEndDate, 'MM/DD/YYYY').format('MM/DD/YYYY')
        });
      }
    }
  },
  beforeMount() {
    this.startDate = this.$moment(this.$store.state.common.datePicked.startDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
    this.endDate = this.$moment(this.$store.state.common.datePicked.endDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
    this.items = this.cleaningInfo !== null ? this.cleaningInfo.departures : [];
  },
  methods: {
    getCleaningInfo() {
      const params = {
        startDate: this.datePicked.startDate,
        endDate: this.datePicked.endDate
      };
      params.startDate = this.$moment(this.datePicked.startDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
      params.endDate = this.$moment(this.datePicked.endDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
      this.$helper.showLoading();
      VendorApi
        .getCleaningInfo(params)
        .then((response) => {
          this.items = response.data.result.departures;
          this.$store.dispatch('common/updateCleaningInfo', response.data.result);
          this.$helper.hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$helper.hideLoading();
        });
    },

    toggleStatus(status, unitId, reservationNumber) {
      this.$helper.showLoading();
      status = !status;
      const params = {
        status: status ? 'CLEAN' : 'DIRTY',
        unitId: unitId,
        reservationNumber: reservationNumber
      };
      VendorApi
        .updateCleaningStatus(params)
        .then((response) => {
          this.$helper.hideLoading();
          this.successMessage(response.data.detail);
        })
        .catch((error) => {
          this.$helper.hideLoading();
          this.errorMessage(error.response.data.detail);
        });
    },

    print() {
      window.print();
    },

    successMessage(message) {
      this.modalImage = '/img/success.png';
      this.apiMessage = message;
      this.apiMessageModal = true;
    },

    errorMessage(message) {
      this.modalImage = '/img/error.png';
      this.apiMessage = message;
      this.apiMessageModal = true;
    }
  }
};
</script>

<template lang="pug">
  section.reservation-container
    .top-panel.bb
      .clearfix.pv-lg
        .float-left
          .top-item.d-inline-block.vertical-middle.mr-lg Viewing Cleaning Data For
          .top-item.d-inline-block.vertical-middle.mr-lg
            datepicker.custom-input(
              :calendar-button="dpkConfig.button"
              :calendar-button-icon="dpkConfig.iconClass"
              :bootstrap-styling="true"
              :format="dpkConfig.format"
              :disabledDates="disabledStartDate"
              v-model="startDate"
            )
          .top-item.d-inline-block.vertical-middle.mr-lg to
          .top-item.d-inline-block.vertical-middle.mr-lg
            datepicker.custom-input(
              :calendar-button="dpkConfig.button"
              :calendar-button-icon="dpkConfig.iconClass"
              :bootstrap-styling="true"
              :format="dpkConfig.format"
              :disabledDates="disabledEndDate"
              v-model="endDate"
            )
          .top-item.d-inline-block.vertical-middle
            button.btn.button.app-button.update-button(
              @click.prevent="getCleaningInfo()"
            )
              img.mr(src="/img/update.png")
              span.vertical-middle Update
        .float-right
          button.btn.button.app-button(@click="print()")
            img.mr(src="/img/print.png")
            span.vertical-middle Print
    .main-content
      .row
        .col-12
          .content-wrap
            b-table.custom-table.rent-night-table(
              :fields="tableFields",
              :items="items"
              responsive
            )
              template(slot="isClean" slot-scope="row")
                b-form-checkbox.app-checkbox(
                  v-model="row.item.isClean"
                  @change="toggleStatus(row.item.isClean, row.item.unitId, row.item.reservationNumber)"
                )
              template(slot="reservationNumber" slot-scope="row")
                span {{ row.item.reservationNumber + ' - ' + row.item.reservationType.name  }}
              template(slot="isPriorityClean" slot-scope="row")
                span {{ row.item.isPriorityClean ? 'Yes' : 'No' }}
            .no-arrivals.ph-md(v-show="!items.length") No reservation match this date range

      b-modal(
        v-model="apiMessageModal"
        :body-class="'p0'"
        :header-class="'modal-small-header p-md'"
        hide-footer
        centered
      )
        template(slot="modal-title")
          img.mr(:src="modalImage")
          span {{apiMessage}}
</template>

<style lang="scss">
@media print {
  .top-panel .clearfix.pv-lg .float-right button.btn.button.app-button {
    display: none;
  }
}
</style>
